export const StageSummary = ({ schema, answers, personalize }) => {
  const rows = schema.sections.flatMap((s) => s.fields)
    .filter((f) => answers[f.key] !== null && answers[f.key] !== undefined && answers[f.key] !== '' && !(Array.isArray(answers[f.key]) && !answers[f.key].length))
    .map((f) => ({ key: f.key, label: personalize(f.label), value: f.type === 'select' ? f.options.find((o) => o.value === answers[f.key])?.label
      : f.type === 'multiselect' ? f.options.filter((o) => answers[f.key].includes(o.value)).map((o) => o.label).join(', ') : String(answers[f.key]) }));
  if (!rows.length) return null;
  return (
    <section className="mt-12" data-testid="stage-summary">
      <div className="eyebrow !text-gold mb-3">Your stage summary</div>
      <p className="text-sm text-matte/60 mb-4">Built only from your answers.</p>
      <dl className="rounded-2xl bg-white border border-matte/10 divide-y divide-matte/10">
        {rows.map((r) => (
          <div key={r.key} className="p-4 md:grid md:grid-cols-3 md:gap-6">
            <dt className="text-[11px] uppercase tracking-[0.16em] text-matte/50">{r.label}</dt>
            <dd className="mt-1 md:mt-0 md:col-span-2 text-sm text-matte whitespace-pre-line">{r.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
